import {AfterViewInit, Component, OnInit} from '@angular/core';
import {UserStore} from 'src/app/modules/authentication/state/user.store';
import {API_PATH, RouterLinks} from '../../constants';
import {DamageImageModel} from '../../models/underwriter.model';
import {newGuid} from '../../questions/question-helper';
import {DamageQuestionPasser} from '../../services/damage-question-passer';
import {GlobalQuestionService} from '../../services/global-question.service';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../../authentication/service/authentication.service';

declare const Dropzone: any;
declare const dropzonePreviewTemplate: any;
declare var $: any;

@Component({
    selector: 'app-damage-images-modal',
    templateUrl: './damage-images-modal.component.html',
    styleUrls: ['./damage-images-modal.component.scss'],
    standalone: false
})

export class DamageImagesModalComponent implements OnInit, AfterViewInit {

  dropZone: any;
  damageQuestion: DamageImageModel;
  acceptedFileTypes = 'image/*,video/mp4,video/x-m4v,video/*';
  questionResources: any[] = [];
  uniqueId = `uploader-${newGuid()}`;
  uploadText = '';
  otherAreaText = '';
  buttonDisabled = true;

  constructor(
    private damageQuestionPasser: DamageQuestionPasser,
    private userStore: UserStore,
    private authService: AuthenticationService,
    private router: Router,
    private globalQuestionService: GlobalQuestionService) {
    this.damageQuestionPasser.updateComponent()
      .subscribe((damageQuestion: DamageImageModel) => {
        if (!damageQuestion || damageQuestion.sender === 'child') {
          return;
        }
        this.authService.refreshToken()
          .subscribe(x => {
            this.userStore.update({
              access_token: x?.access_token,
              refresh_token: x?.refresh_token
            });
            this.setupDropZone();
            this.dropZone.removeAllFiles();
          });
        this.damageQuestion = damageQuestion;
        this.uploadText = '';
        this.otherAreaText = '';
        this.buttonDisabled = true;

        if (this.damageQuestion?.response) {
          this.questionResources = [];
          const response = JSON.parse(this.damageQuestion?.response);
          this.uploadText = response?.note;
          if (damageQuestion.side === 'other') {
            this.otherAreaText = response?.area_name;
          }
          JSON.parse(response?.resources)?.forEach((res: any) => {
            const resource_id = res.resource_id;
            this.globalQuestionService.getUploadedFileDetails(resource_id)
              .subscribe((details: any) => {
                if (!details) {
                  return;
                }
                const mockFile = {
                  name: details[0]?.original_filename,
                  size: details[0]?.file_size
                };
                this.dropZone?.emit('addedfile', mockFile);
                this.dropZone?.emit('thumbnail', mockFile, `${API_PATH.UPLOAD_RESOURCE}/${resource_id}`);
                this.dropZone?.emit('success', mockFile, resource_id);
                this.dropZone?.emit('complete', mockFile);
                this.dropZone.files.push(mockFile);
                this.buttonDisabled = false;
              });
          });
        }
      });
  }

  ngOnInit(): void {
    this.damageQuestionPasser.showDamageImageModalObservable
      .subscribe(x => {
        if (x) {
          this.showModal();
        } else {
          this.hideModal();
        }
      });
  }

  showModal(): void {
    $('#images-of-damage-modal').modal('show');
  }

  hideModal(): void {
    $('#images-of-damage-modal').modal('hide');
  }
  setupDropZone(): void {
    this.dropZone = new Dropzone(`#${this.uniqueId}`, {
      autoProcessQueue: true, // if false, call this.dropZone.processQueue()
      autoDiscover: false,
      acceptedFiles: this.acceptedFileTypes,
      previewTemplate: dropzonePreviewTemplate,
      thumbnailWidth: 204,
      thumbnailHeight: 204,
      url: API_PATH.UPLOAD_RESOURCE,
      headers: {
        Authorization: `Bearer ${this.userStore.getValue()?.access_token}`
      },
    }).on('thumbnail', (file: any) => {
      $(file.previewElement).addClass('has-thumbnail');
    }).on('uploadprogress', (file: any, progress: any, bytesSent: any) => {
      console.log(this.dropZone);
    }).on('success', (file: any, response: any) => {
      console.log(this.dropZone);
      if (this.questionResources.length) {
        const questionResources = this.questionResources.find((qr: any) => qr.id === `${this.damageQuestion.side}-${this.damageQuestion.question.cent_aq_question_id}`);
        if (questionResources) {
          const resources = questionResources.resources;
          resources.push({ resource_id: response });
        } else {
          const resources: any[] = [];
          resources.push({ resource_id: response });
          this.questionResources.push({ id: `${this.damageQuestion.side}-${this.damageQuestion.question.cent_aq_question_id}`, resources });
        }
      } else {
        const resources: any[] = [];
        resources.push({ resource_id: response });
        this.questionResources.push({ id: `${this.damageQuestion.side}-${this.damageQuestion.question.cent_aq_question_id}`, resources });
      }
      if (this.questionResources.length) {
        this.buttonDisabled = false;
      }
    }).on('error', (file: any, response: any) => {
      console.log(response, 'Redirecting...');
      if (response?.indexOf('401') !== -1) {
        this.router.navigate([RouterLinks.Login], {queryParams: {returnUrl: this.router.routerState.snapshot.url}});
      }
    });
  }
  ngAfterViewInit(): void {

  }

  cancelChanges(hideModal: boolean = true): void {
    this.dropZone.removeAllFiles();
    this.uploadText = '';
    this.otherAreaText = '';
    this.buttonDisabled = true;
    if(hideModal){
      this.hideModal();
    }
  }

  saveChanges(): void {
    const questionResources = this.questionResources.find((qr: any) => qr.id === `${this.damageQuestion.side}-${this.damageQuestion.question.cent_aq_question_id}`);
    let response = '';
    if (this.damageQuestion.side === 'other') {
      response = JSON.stringify({resources: JSON.stringify(questionResources.resources), note: this.uploadText, area_name: this.otherAreaText});
    } else {
      response = JSON.stringify({resources: JSON.stringify(questionResources.resources), note: this.uploadText});
    }
    this.dropZone.removeAllFiles();
    this.uploadText = '';
    this.otherAreaText = '';
    this.buttonDisabled = true;
    this.damageQuestion.response = response;
    this.damageQuestion.sender = 'child';
    this.damageQuestionPasser.passDamageQuestion(this.damageQuestion);
    this.hideModal();
  }
}
